import Vue from 'vue'
import Router from 'vue-router'
import header from '@/components/zzj/header'
import footer from '@/components/zzj/footer'
import index from '@/components/index'
import index_ESP from '@/components/index_ESP'
import product from '@/components/product'
import product_ESP from '@/components/product_ESP'
import download from '@/components/download'
import download_ESP from '@/components/download_ESP'
import about from '@/components/about'
import about1 from '@/components/about1'
import about2 from '@/components/about2'
import about3 from '@/components/about3'
import about4 from '@/components/about4'
import about_ESP from '@/components/about_ESP'
import about_ESP1 from '@/components/about_ESP1'
import about_ESP2 from '@/components/about_ESP2'
import about_ESP3 from '@/components/about_ESP3'
import about_ESP4 from '@/components/about_ESP4'
import support from '@/components/support'
import support_ESP from '@/components/support_ESP'
import product_item from '@/components/product_item'
import product_item_ESP from '@/components/product_item_ESP'
import contact from '@/components/contact'
import contact_ESP from '@/components/contact_ESP'
import ppp from '@/components/zzj/ppp'
import page from '@/components/page'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/ESP',
      name: 'index_ESP',
      component: index_ESP
    },
    {
      path: '/ppp',
      name: 'ppp',
      component: ppp
    },
    {
      path: '/page',
      name: 'page',
      component: page
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/product_ESP',
      name: 'product_ESP',
      component: product_ESP
    },
    {
      path: '/product_item',
      name: 'product_item',
      component: product_item
    },
    {
      path: '/product_item_ESP',
      name: 'product_item_ESP',
      component: product_item_ESP
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/about1',
      name: 'about1',
      component: about1
    },
    {
      path: '/about2',
      name: 'about2',
      component: about2
    },
    {
      path: '/about3',
      name: 'about3',
      component: about3
    },
    {
      path: '/about4',
      name: 'about4',
      component: about4
    },
    {
      path: '/about_ESP',
      name: 'about_ESP',
      component: about_ESP
    },
    {
      path: '/about_ESP1',
      name: 'about_ESP1',
      component: about_ESP1
    },
    {
      path: '/about_ESP2',
      name: 'about_ESP2',
      component: about_ESP2
    },
    {
      path: '/about_ESP3',
      name: 'about_ESP3',
      component: about_ESP3
    },
    {
      path: '/about_ESP4',
      name: 'about_ESP4',
      component: about_ESP4
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/download_ESP',
      name: 'download_ESP',
      component: download_ESP
    },
    {
      path: '/header',
      name: 'header',
      component: header
    },
    {
      path: '/footer',
      name: 'footer',
      component: footer
    },
    {
      path: '/support',
      name: 'support',
      component: support
    },
    {
      path: '/support_ESP',
      name: 'support_ESP',
      component: support_ESP
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/contact_ESP',
      name: 'contact_ESP',
      component: contact_ESP
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js